let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("aoNSR")]).then(() => parcelRequire('9AdN4'));